import React, { useEffect } from 'react';

// Material
import { TextField, InputAdornment, IconButton } from '@material-ui/core';

// Material Icons
import CheckIcon from '@material-ui/icons/Check';

// Formik
import { FormikProps } from 'formik';

// Remask
// @ts-ignore
import { mask as masker, unMask } from 'remask';

// Constants
import MASKS from 'constants/masks';

// Styles
import useStyles from './styles';

interface PhoneMaskInterface {
  formik: FormikProps<any>;
  withMargin?: boolean;
  classes?: {
    root?: string;
  };
  className?: string;
  checkIcon?: boolean;
  handleClickOnCheckIcon?: () => void;
  disabled?: boolean;
  phone?: string;
  notfullWidth?: boolean;
}

type Props = PhoneMaskInterface;

const PhoneMask: React.FC<Props> = ({
  formik,
  withMargin,
  classes,
  className,
  checkIcon,
  handleClickOnCheckIcon,
  disabled,
  phone,
  notfullWidth,
}) => {
  const { closeIconContainer } = useStyles();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const originalValue = phone
      ? unMask(phone).replace(/^55/, '')
      : unMask(event.target.value);
    const maskedValue = masker(originalValue, [MASKS.PHONE, MASKS.PHONE_DDI]);
    formik.setFieldValue('phone', maskedValue);
  };

  useEffect(() => {
    const format = formik.values?.phone?.replace(/\+\s?55/, '');
    const eventMock = {
      target: {
        value: format,
      },
    };
    handleChange(eventMock as React.ChangeEvent<HTMLInputElement>);
  }, [formik.values.phone]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <TextField
      disabled={disabled}
      className={className || classes?.root}
      classes={{
        root: classes?.root,
      }}
      InputProps={{
        startAdornment: <InputAdornment position='start'>+55</InputAdornment>,
        endAdornment: checkIcon ? (
          <InputAdornment position='start'>
            {(phone || formik.values.phone) && (
              <IconButton
                onClick={() => {
                  if (handleClickOnCheckIcon instanceof Function) {
                    handleClickOnCheckIcon();
                  }
                }}
                className={closeIconContainer}>
                <CheckIcon fontSize='small' />
              </IconButton>
            )}
          </InputAdornment>
        ) : null,
      }}
      name='phone'
      fullWidth={!notfullWidth}
      id='text-field-phone'
      // label='Telefone'
      variant='outlined'
      margin={withMargin ? 'normal' : 'none'}
      placeholder={MASKS.PHONE_DDI}
      error={Boolean(
        formik.errors &&
          formik.touched &&
          formik.errors.phone &&
          formik.touched.phone,
      )}
      helperText={
        formik.errors &&
        formik.touched &&
        formik.touched.phone &&
        formik.errors.phone
      }
      onBlur={formik.handleBlur}
      onChange={handleChange}
      value={phone || formik.values.phone}
    />
  );
};

export default PhoneMask;
export { PhoneMask };
